import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CssBaseline as MuiCssBaseline, ThemeProvider as MuiThemeProvider, } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { de, enUS } from 'date-fns/locale';
import { useMemo } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { Locale } from '@zurich/common/types';
import { createTheme } from '../../styles/theme';
import { SnackbarProvider } from '../SnackbarProvider';
function getDateFnsLocale(locale) {
    switch (locale) {
        case Locale.DE:
            return de;
        case Locale.EN:
            return enUS;
        default:
            throw new Error(`Locale not implemented for theme: ${locale}`);
    }
}
export function ThemeProvider(props) {
    const { type, locale, children } = props;
    const { t } = useTranslation();
    const [theme, dateFnsLocale] = useMemo(() => [createTheme(type, locale), getDateFnsLocale(locale)], [locale, type]);
    return (_jsxs(MuiThemeProvider, { theme: theme, children: [_jsx(MuiCssBaseline, {}), _jsx(LocalizationProvider, { adapterLocale: dateFnsLocale, dateAdapter: AdapterDateFns, localeText: {
                    cancelButtonLabel: t('common:button_label.cancel'),
                    okButtonLabel: t('common:button_label.accept'),
                }, children: _jsx(SnackbarProvider, { children: children }) })] }));
}
